// src/services/api/dropshipping.js
import { apiClient } from './base';

// ---- Provider Status (lightweight check for product pages) ----
export const getProviderStatus = async () => {
  const response = await apiClient.get('/dropshipping/provider-status');
  return response.data;
};

// ---- Settings ----
export const getDropshippingSettings = async () => {
  const response = await apiClient.get('/dropshipping/settings');
  return response.data;
};

export const updateDropshippingSettings = async (data) => {
  const response = await apiClient.put('/dropshipping/settings', data);
  return response.data;
};

export const uploadKycDocuments = async (formData) => {
  const response = await apiClient.post('/dropshipping/settings/kyc', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// ---- Banks ----
export const getBanks = async () => {
  const response = await apiClient.get('/dropshipping/banks');
  return response.data;
};

export const getBankBranches = async (bankId) => {
  const response = await apiClient.get(`/dropshipping/banks/${bankId}/branches`);
  return response.data;
};

// ---- Provider Product Management (provider-facing) ----
export const getProviderProducts = async (params = {}) => {
  const response = await apiClient.get('/dropshipping/provider/products', { params });
  return response.data;
};

export const updateProviderProductDropshipping = async (id, type, data) => {
  const response = await apiClient.put(`/dropshipping/provider/products/${id}`, data, { params: { type } });
  return response.data;
};

// ---- Provider Catalog & Product Assignment ----
export const getProviderCatalog = async (params = {}) => {
  const response = await apiClient.get('/dropshipping/products/catalog', { params });
  return response.data;
};

export const getProviders = async (params = {}) => {
  const response = await apiClient.get('/dropshipping/products/providers', { params });
  return response.data;
};

export const assignProduct = async (data) => {
  const response = await apiClient.post('/dropshipping/products/assign', data);
  return response.data;
};

export const updateAssignedPrice = async (id, data) => {
  const response = await apiClient.put(`/dropshipping/products/assign/${id}/price`, data);
  return response.data;
};

export const unassignProduct = async (id) => {
  const response = await apiClient.delete(`/dropshipping/products/assign/${id}`);
  return response.data;
};

// ---- Reseller Requests ----
export const applyToProvider = async (data) => {
  const response = await apiClient.post('/dropshipping/requests', data);
  return response.data;
};

export const getOutgoingRequests = async () => {
  const response = await apiClient.get('/dropshipping/requests/outgoing');
  return response.data;
};

export const getIncomingRequests = async () => {
  const response = await apiClient.get('/dropshipping/requests/incoming');
  return response.data;
};

export const reviewRequest = async (id, data) => {
  const response = await apiClient.put(`/dropshipping/requests/${id}/review`, data);
  return response.data;
};

// ---- Invoices ----
export const getDropshippingInvoices = async (params = {}) => {
  const response = await apiClient.get('/dropshipping/invoices', { params });
  return response.data;
};

export const getDropshippingInvoiceById = async (id) => {
  const response = await apiClient.get(`/dropshipping/invoices/${id}`);
  return response.data;
};

export const bulkUpdateDropshippingInvoiceStatuses = async (invoiceIds, status) => {
  const response = await apiClient.put('/dropshipping/invoices/bulk-status', { invoiceIds, status });
  return response.data;
};

export const getProviderDropshipperShops = async () => {
  const response = await apiClient.get('/dropshipping/provider/dropshipper-shops');
  return response.data;
};

// ---- Invite Link ----
export const generateInviteLink = async () => {
  const response = await apiClient.post('/dropshipping/settings/generate-invite');
  return response.data;
};

export const getProviderByInviteHash = async (hash) => {
  const response = await apiClient.get(`/dropshipping/invite/${hash}`);
  return response.data;
};

export const directJoinProvider = async (data) => {
  const response = await apiClient.post('/dropshipping/requests/direct-join', data);
  return response.data;
};
